import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SettingType } from '@shared/enums';
import { RequestHelper } from '@shared/helpers';
import { Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';
import { PaginationRequest } from './models/pagination/pagination.request.model';

@Injectable({ providedIn: 'root' })
export class SettingApiService {
    constructor(
        private httpClient: HttpClient,
        private environmentService: EnvironmentService
    ) {}

    private get url(): string {
        return `${this.environmentService.getCurrentApiUrl()}/settings`;
    }

    getAll(types?: SettingType[]): Observable<any> {
        const params = RequestHelper.createRequestOption({ types });
        return this.httpClient.get<any>(`${this.url}/all`, {
            params
        });
    }

    getSettings(req: PaginationRequest): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.httpClient.get<any>(this.url, { params: options });
    }

    createSetting(setting: any): Observable<any> {
        return this.httpClient.post<any>(this.url, setting);
    }

    updateSetting(setting: any): Observable<any> {
        return this.httpClient.put<any>(this.url, setting);
    }

    deleteSetting(id: string): Observable<any> {
        return this.httpClient.delete<any>(`${this.url}/${id}`);
    }
}
